import { render, staticRenderFns } from "./activity-plot.vue?vue&type=template&id=b384042a&scoped=true&"
import script from "./activity-plot.vue?vue&type=script&lang=js&"
export * from "./activity-plot.vue?vue&type=script&lang=js&"
import style0 from "./activity-plot.vue?vue&type=style&index=0&id=b384042a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b384042a",
  null
  
)

export default component.exports